import i18n from "../Services/i18n";
import styles from "../Components/Modal/DeletionConfirmationModal.module.css";
import { useModal } from "../Context/ModalContext";
import { useToasts } from "../LayoutComponents/ToastContext";

// Cette fonction est appelée depuis un composant React
export function useDeletionConfirmationModal() {
  const { openModal, closeModal } = useModal();
  const { addToast } = useToasts();

  return ({
    entityId,
    entityTitle,
    entitySubTitle,
    entityImage,
    icon,
    deleteFunction,
    onClose,
  }) => {
    openModal({
      title: i18n.t("Modal.ConfirmDeleteHeader"),
      icon: icon,
      dangerMode: true,
      wideMode: false,
      onSave: async () => {
        try {
          await deleteFunction(entityId);
          onClose?.(true);
          closeModal();
        } catch (ex) {
          console.error(ex);
          addToast(i18n.t("Generic.ServerError"), "BACKENDERROR", "ERROR", true);
          return false;
        }
      },
      onClose: () => onClose?.(false),
      content: (
        <div className={styles.container}>
          {entityImage && <img src={entityImage} alt="entity" className={styles.icon} />}
          <p className={styles.entityName}>{entityTitle}</p>
          {entitySubTitle && <p className={styles.entitySubName}>{entitySubTitle}</p>}
          <p className={styles.message}>{i18n.t("Modal.ConfirmDeleteMessage")}</p>
        </div>
      ),
    });
  };
}
